/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import './RMDTable.scss';

import React from 'react';
/* eslint-disable */
const TablePagination = (props) => {
    if (props) {
        const { isCollapsed, remainingLength } = props.pagination;
        if (isCollapsed) {
            return (<tr className="expandText">
                <td>
                    <a onClick={(e) => props.handleClick(e)}>
                        View complete RMD Summary breakdown. {remainingLength} more rows available.
                </a>
                </td>
            </tr>
            );
        }
    }
    return null;
};
/* eslint-enable */
export default TablePagination;